export { updateFriendlyNames } from '../_internal/actions/updateFriendlyNames';
export { setFriendlyNames } from '../_internal/actions/setFriendlyNames';